import { render } from "./CustomerCampaign.vue?vue&type=template&id=4a17cfa2&scoped=true&lang=pug"
import script from "./CustomerCampaign.vue?vue&type=script&lang=js"
export * from "./CustomerCampaign.vue?vue&type=script&lang=js"

import "./CustomerCampaign.vue?vue&type=style&index=0&id=4a17cfa2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a17cfa2"]])

export default __exports__